const domain = 'api.econsulttest.health';
const ROOT_URL = `https://${domain}`;

export const testConfig = {
  SUMMARISER: {
    BASE_URL: `https://summariser.${domain}`,
    HOST: `${ROOT_URL}/summariser`,
    WEBSOCKET: `wss://${domain}/summariser`,
  },
  AUTH: {
    HOST: `${ROOT_URL}/auth`,
  },
  USER_MANAGEMENT: {
    HOST: `${ROOT_URL}/usermanagement`,
  },
  CUSTOMISATION: {
    HOST: `${ROOT_URL}/customisation`,
  },
  SMART_INBOX: {
    HOST: `${ROOT_URL}/workflow/home`,
  },
  E_LITE: {
    HOST: 'https://elite.econsulttest.health',
  },
  SETTINGS: {
    HOST: 'https://settings.econsulttest.health',
  },
  REPORTING: {
    HOST: `${ROOT_URL}/workflow/reports`,
  },
  STRIPE: {
    PUBLISHABLE_KEY:
      'pk_test_51RxnLXJvAPspDFplzStjxgnOkimJBAGCRg5EOQyri9Tm8XTsrIHiDMxWGZWBoileCHiT46SklJOO1vXRhUM8fQte00WFesjCyU',
  },
};
